// @ts-nocheck
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import {
    chain,
    SendTracking,
    SetCartStatus,
} from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrder";
import { addToChainAfter, replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";

import cloneDeep from "lodash/cloneDeep";
// Starter Custom Code
import { dispatchPurchaseEvent } from "@store/Framework/Services/AnalyticsService";

addToChainAfter(chain, SetCartStatus, props => {
    const { cartToUpdate } = props;

    const state = props.getState();
    const signature = state.bunzl.pages.Signature.Signature;

    cartToUpdate.additionalEmails = signature?.customerEmail || cartToUpdate.additionalEmails;

    if (signature) {
        cartToUpdate.properties.signatureName = signature.customerName;
        cartToUpdate.properties.signatureEmail = signature?.customerEmail || "";
        cartToUpdate.properties.signatureBase64 = signature.customerSignature;
        cartToUpdate.properties.signatureTimestamp = signature.timestamp;
    }
});

replaceInChain(chain, SetCartStatus, props => {
    const state = props.getState();
    const { cartId } = state.pages.checkoutReviewAndSubmit;
    const cart = cartId ? getCartState(state, cartId).value : getCurrentCartState(state).value;

    if (!cart) {
        throw new Error("There was no current cart and we are trying to place the current cart as an order.");
    }

    const notes = state.pages.checkoutShipping.editedCartNotes || cart.notes; // Starter Custom Code
    const { authorizedPickUpPerson, isApplicable } = state.bunzl.pages.checkoutReviewAndSubmit;

    const newStatus = cart?.requiresApproval
        ? "AwaitingApproval"
        : props.parameter?.isPending
          ? "PendingPaymentValidation"
          : "Submitted";

    props.cartToUpdate = {
        ...cloneDeep(cart),
        status: newStatus,
        poNumber: props.parameter.poNumber,
        customerVatNumber: props.parameter.vatNumber || "",
        notes, // Starter Custom Code
        properties: {
            ...cart.properties,
            authorizedPickUpPerson: isApplicable ? authorizedPickUpPerson.trim() : "",
        },
    };
});

replaceInChain(chain, SendTracking, props => {
    dispatchPurchaseEvent(props.cartToUpdate); // Starter Custom Code
});
